{
  "name": "@jspsych/plugin-html-slider-response",
  "version": "2.1.0",
  "description": "a jspsych plugin for free response survey questions",
  "type": "module",
  "main": "dist/index.cjs",
  "exports": {
    "import": "./dist/index.js",
    "require": "./dist/index.cjs"
  },
  "typings": "dist/index.d.ts",
  "unpkg": "dist/index.browser.min.js",
  "files": [
    "src",
    "dist"
  ],
  "source": "src/index.ts",
  "scripts": {
    "test": "jest",
    "test:watch": "npm test -- --watch",
    "tsc": "tsc",
    "build": "rollup --config",
    "build:watch": "npm run build -- --watch"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/jspsych/jsPsych.git",
    "directory": "packages/plugin-html-slider-response"
  },
  "author": "Josh de Leeuw",
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/jspsych/jsPsych/issues"
  },
  "homepage": "https://www.jspsych.org/latest/plugins/html-slider-response",
  "peerDependencies": {
    "jspsych": ">=7.1.0"
  },
  "devDependencies": {
    "@jspsych/config": "^3.2.0",
    "@jspsych/test-utils": "^1.2.0"
  }
}
